import React, {Component} from 'react';
import {Button, Col, Row} from "reactstrap";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {unsetQuestionResponse} from "../../reducers/questionResponses/actions";
import PauseButton from './components/PauseButton';
import ContactButton from "./components/ContactButton";
import classnames from "classnames";
import {FormattedMessage} from "react-intl";
import {setSurveyNavHideValidation} from "../../reducers/surveyNav/actions";
import sendMessageToPreview from "../../utils/sendMessageToPreview";

class Footer extends Component {

	constructor(props) {
		super(props);
		this.state = {width: 0, height: 0};

		this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
		this.handlerClearQuestionResponses = this.handlerClearQuestionResponses.bind(this);
		this.isSingleMatrixQuestionRightNow = this.isSingleMatrixQuestionRightNow.bind(this);
		this.isLastPage = this.isLastPage.bind(this);
	}

	componentDidMount() {
		this.updateWindowDimensions();
		window.addEventListener('resize', this.updateWindowDimensions);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateWindowDimensions);
	}

	updateWindowDimensions() {
		this.setState({width: window.innerWidth, height: window.innerHeight});
	}

	handlerClearQuestionResponses() {
		this.props.pages[this.props.pageIndex].questions.map(question => {
			this.props.unsetQuestionResponse(question.id);
		});
		this.props.setSurveyNavHideValidation(true)
		sendMessageToPreview();
	}

	isSingleMatrixQuestionRightNow() {
		const {pages, surveyNav, pageIndex} = this.props;
		const {width} = this.state;

		if (typeof pageIndex === "undefined") {
			return false;
		}
		const currentPage = pages[pageIndex];
		if (currentPage) {
			if (currentPage.questions.length === 1) {
				const question = currentPage.questions[0];
				if ((question.type === 'matrix' || question.type === 'matrixMulti' || question.type === 'matrixDropdown') && question.presentationType === 'table') {
					if (question.transposed) {
						if (question.columns.length === 1) {
							return false;
						}
					} else if (question.rows.length === 1) {
						return false;
					}

					if (width > 767) {
						return false;
					}
					if (surveyNav.showNextButton) {
						return false;
					}

					return true;
				}

				if ((question.type === 'matrix' || question.type === 'matrixMulti' || question.type === 'matrixDropdown') && question.presentationType === 'carousel') {
					if (question.transposed) {
						if (question.columns.length === 1) {
							return false;
						}
					} else if (question.rows.length === 1) {
						return false;
					}

					if (surveyNav.showNextButton) {
						return false;
					}

					return true;
				}
			}
		}

		return false;
	}

	isLastPage() {
		const {pages, progress, pageIndex} = this.props;
		if (!progress || progress.empty) {
			return false;
		}
		const lastPageId = pages ? progress.pageOrder[progress.pageOrder.length - 1] : 0;
		const currentPage = pages[pageIndex]

		return currentPage && currentPage.id === lastPageId
	}

	buttonVisible(type) {
		const {pages, surveyResponse, pageIndex} = this.props;
		const currentPage = pages[pageIndex];
		const isInvitation = (surveyResponse.status === 1 || _.isEmpty(pages)) && surveyResponse.invitationText;

		switch (type) {
			case 'start':
				return !surveyResponse.isEnded && isInvitation;
			case 'prev':
				return !surveyResponse.isEnded && !isInvitation && pages[pageIndex] && !pages[pageIndex].hideNavigationPreviousButton;
			case 'clear':
				return !surveyResponse.isEnded && !isInvitation && pages[pageIndex] && !pages[pageIndex].hideNavigationClearButton;
			case 'next':
				return currentPage && this.isLastPage() === false && !surveyResponse.isEnded && !isInvitation && pages[pageIndex] && !pages[pageIndex].hideNavigationNextButton && !this.isSingleMatrixQuestionRightNow();
			case 'end':
				return currentPage && this.isLastPage() === true && !surveyResponse.isEnded && !isInvitation && !this.isSingleMatrixQuestionRightNow();
			case 'pause':
				return !surveyResponse.isRegisteredUser && !isInvitation && surveyResponse.survey.pauseEnable;
			case 'contact':
				return surveyResponse.survey.contact;

			default:
				return false;
		}
	}

	canShowUndoButton() {
		const {surveyResponse, pageIndex} = this.props;

		if (pageIndex === 0 && surveyResponse.collector.type === 'Test' && surveyResponse.collector.showInvitationText === false) {
			return false;
		}

		return true;
	}

	render() {
		const {disableButtons, page, surveyResponse, surveyNav, survey} = this.props;

		if (!surveyNav.visibility) {
			return null;
		}

		return (
			<React.Fragment>
				<div className="navigation" style={{minHeight: "42px"}}>
					<Row className="mt-4">
						<Col>
							<Row className="m-0">
								{this.canShowUndoButton() && <Col xs={6} md={2} lg={2} className="pr-2 pr-md-1 pl-0">
									{<Button
										disabled={disableButtons || !page.minTimeValidate}
										color=""
										className={classnames({
											'btn-prev w-100 mb-3 mb-md-1': true,
											'd-none': !this.buttonVisible('prev')
										})}
										onClick={() => this.props.onChangePage(-1)}
									>{survey.buttonPrev ? survey.buttonPrev :
										<span><i className="fas fa-chevron-left position-absolute"/><FormattedMessage
											id="footer.buttonPrev.text"
										>{msg => msg}</FormattedMessage></span>}</Button>}
								</Col>}
								<Col xs={6} md={2} lg={2} className="pl-2 pl-md-1 pr-0">
									{this.buttonVisible('clear') && <Button
										disabled={disableButtons}
										color=""
										className="w-100 mb-3 mb-md-1 btn-clear"
										onClick={this.handlerClearQuestionResponses}
									>{survey.buttonClear ? survey.buttonClear : <FormattedMessage
										id="footer.buttonClear.text"
									>{msg => msg}</FormattedMessage>}</Button>}
								</Col>
								<Col
									md={4}
									className="d-none d-lg-flex flex-row-reverse align-items-center pause-contact-container"
								>
									{this.buttonVisible('pause') && <PauseButton surveyResponse={surveyResponse}/>}

									{this.buttonVisible('contact') &&
									<ContactButton surveyId={surveyResponse.survey.id}/>}
								</Col>
								<Col xs={12} md={3} lg={4} className="px-0 ml-auto" style={{minHeight: "42px"}}>
									{this.buttonVisible('next') && <Button
										disabled={disableButtons || !page.minTimeValidate}
										color=""
										className="w-100 float-right btn-start next-answer"
										onClick={() => this.props.onChangePage(1)}
									>{survey.buttonNext ? survey.buttonNext : <span><FormattedMessage
										id="footer.buttonNext.text"
									>{msg => msg}</FormattedMessage><i
										className="fas fa-chevron-right position-absolute"
									/></span>}</Button>}

									{<Button
										disabled={disableButtons || !page.minTimeValidate}
										color=""
										className={classnames({
											'w-100 float-right btn-next btn-end': true,
											'd-none': !this.buttonVisible('end')
										})}
										onClick={() => this.props.onChangePage(1)}
									>{survey.buttonEnd ? survey.buttonEnd : <span><FormattedMessage
										id="footer.buttonEnd.text"
									>{msg => msg}</FormattedMessage><i
										className="fas fa-chevron-right position-absolute"
									/></span>}</Button>}

									{this.buttonVisible('start') && <Button
										disabled={disableButtons}
										color=""
										className="w-100 position-absolute btn-start"
										onClick={() => this.props.onChangePage(1)}
									>{survey.buttonStart ? survey.buttonStart : <span><FormattedMessage
										id="footer.buttonStart.text"
									>{msg => msg}</FormattedMessage><i
										className="fas fa-chevron-right float-right ml-2"
									/></span>}</Button>}
								</Col>
							</Row>
						</Col>
					</Row>
				</div>
				{(this.buttonVisible('pause') || this.buttonVisible('contact')) &&
				<Col sm={12} className="d-flex flex-column d-lg-none pause-contact-container mt-3 mb-3 p-0">
					{this.buttonVisible('pause') && <PauseButton surveyResponse={surveyResponse}/>}
					{this.buttonVisible('contact') && <ContactButton surveyId={surveyResponse.survey.id}/>}
				</Col>}
			</React.Fragment>
		)
	}
}

Footer.propTypes = {
	onChangePage: PropTypes.func.isRequired,
	pageIndex: PropTypes.number.isRequired,
	disableButtons: PropTypes.bool.isRequired,
	surveyNav: PropTypes.shape({
		visibility: PropTypes.bool.isRequired,
		showNextButton: PropTypes.bool.isRequired,
	}).isRequired,
};

function mapStateToProps(state) {
	return {
		surveyNav: state.surveyNav,
		messageTexts: state.surveyResponse.survey.messageTexts,
		pages: state.pages,
		surveyResponse: state.surveyResponse,
		progress: state.progress,
		page: state.page,
		survey: state.survey,
	}
}

export default connect(mapStateToProps, {unsetQuestionResponse, setSurveyNavHideValidation})(Footer);
